import {
  Badge,
  BadgeProps,
  BoxProps,
  Button,
  ButtonProps,
  Center,
  Text,
} from "@chakra-ui/react";

interface Props extends ButtonProps {
  href: string;
}

interface CustomTagProps extends BoxProps {
  tag: string;
}

export const CustomButton = (props: Props) => {
  return (
    <Button
      as="a"
      size="sm"
      fontSize="12"
      fontFamily="medium"
      flex={{ base: 1, md: "initial" }}
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      {props.children}
    </Button>
  );
};

export const CustomBadge = (props: BadgeProps) => {
  return (
    <Badge
      fontSize="10px"
      lineHeight="12px"
      bg="brand.primary"
      color="black"
      p="4px 8px"
      borderRadius="12px"
      {...props}
    >
      {props.children}
    </Badge>
  );
};

export const CustomBoostTag = (props: CustomTagProps) => {
  return (
    <Center
      flex={1}
      height="20px"
      bg="brand.warning"
      px=".5rem"
      borderRadius="6px"
      mt=".25rem"
      minWidth="106.13px"
      _dark={{
        color: "black",
      }}
      {...props}
    >
      <Text fontSize="10px" fontFamily="bold" lineHeight="1rem">
        {props.tag}
      </Text>
    </Center>
  );
};
